export default "__VITE_ASSET__2cf534e9__"